/**
 * these are functions that can be called from anywhere to
 * enter and exit fullscreen mode on the browser
 */

export const requestFullScreen = () => {
    try {
        const element = document.documentElement
        if (element.requestFullscreen) {
            element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen()
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen()
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen()
        }
    } catch (e) {}
}

export const exitHoverPanel = () => {
    parent.postMessage('closeHover', '*')
}

export const exitFullScreen = () => {
    try {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
        }
    } catch (e) {}
}

export const isFullScreen = () =>
    window.fullScreen || (window.innerWidth == screen.width && window.innerHeight == screen.height)

// the following test for fullscreen in iframe.  device slice not always reliable, perhaps due to race conditions
export const isFullScreenActive = () =>
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
